import { useQuery } from "@tanstack/react-query";
import { api } from "../data/api";
import { readStoredDefaultAccount, storeDefaultAccount } from "../data/defaultAccount";
import { useApp } from "../data/StoreContext";

export interface Me {
  defaultAccountId: string | null;
}

export function useMe() {
  const { session } = useApp();
  return useQuery({
    queryKey: ["me"],
    queryFn: async () => {
      const me = await api<Me & { displayName: string }>("/me");
      storeDefaultAccount(session.userId, me.defaultAccountId);
      return me;
    },
    retry: false,
    staleTime: 5 * 60_000,
  });
}

/**
 * The user's Quick Add account: from `/me` when it has answered, else as last remembered on this
 * device (offline, or before `/me` resolves). `null`/`undefined` = use the first account.
 */
export function useDefaultAccountId(): string | null | undefined {
  const { session } = useApp();
  const me = useMe();
  return me.data ? me.data.defaultAccountId : readStoredDefaultAccount(session.userId);
}
